// * Bootstrap libraries
import './_bootstrap';

document.addEventListener('DOMContentLoaded', function() {
    // Set all links in additional documents field to open in new tab
    const additionalDocLinks = document.querySelectorAll('.field--name-field-additional-documents a');
    additionalDocLinks.forEach(link => {
        link.setAttribute('target', '_blank');
    });
});